import { ETripEvent } from 'detailsv2/structure';
export { dragAndDrop } from '../../../constansts';

// export const COLOR_MAP = new Map<ETripEvent, string>([
//   [ETripEvent.Activity, 'rgba(176, 208, 135, 0.5)'],
// ]);

export const COLOR_MAP = {
  [ETripEvent.Activity]: 'rgba(176, 208, 135, 0.5)',
  [ETripEvent.Flight]: 'rgba(238, 195, 213, 0.52)',
  [ETripEvent.Transfer]: 'rgba(200, 219, 35, 0.3)',
  [ETripEvent.Area]: 'rgba(120, 80, 151, 0.25)',
  [ETripEvent.Accommodation]: 'rgba(214, 228, 252, 0.8)',
  [ETripEvent.Information]: 'rgba(234, 171, 127, 0.5)',
};

// [ETripEvent.Activity]: 'rgba(176, 208, 135, 1)', // 0.5
// [ETripEvent.Flight]: 'rgba(238, 195, 213, 1)', // 0.52
// [ETripEvent.Transfer]: 'rgba(200, 219, 35, 1)', // 0.3
// [ETripEvent.Area]: 'rgba(120, 80, 151, 1)', // 0.25
// [ETripEvent.Accommodation]: 'rgba(214, 228, 252, 1)', // 0.8
// [ETripEvent.Information]: 'rgba(234, 171, 127, 1)', // 0.5
